// extracted by mini-css-extract-plugin
export default {"next-button":"NextArrow_next-button__ACy2P"};